import { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { WEIGHT_UNIT } from '../../../../../../types/enum';
import { convertWeight } from '../../../../../../lib/utils';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const WeeksByCalorie = ({ goals, userDetail, selectedOption, preference }) => {
  const [data, setData] = useState([]);
  const [weeks, setWeeks] = useState('');

  useEffect(() => {
    if (selectedOption) {
      const goalWeight = Number(goals.weight);
      const currentWeight = userDetail.weight;
      const weekCount = Math.ceil(
        (goalWeight - currentWeight) / selectedOption.weight
      );
      setData([currentWeight, goalWeight]);
      setWeeks(weekCount);
    }
  }, [selectedOption]);

  return (
    <div className='py-4 text-white'>
      <div className='text-center text-lg font-bold'>About {weeks} weeks</div>
      <Line
        options={{
          responsive: true,
          plugins: {
            legend: {
              display: false,
            },
            title: {
              display: false,
            },
          },
        }}
        data={{
          labels: ['Current', '🎯 Goal'],
          datasets: [
            {
              label: 'kg',
              data,
              borderColor: 'rgba(255, 255, 255, 0.5)',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              lineTension: 0.5,
            },
          ],
        }}
      />
    </div>
  );
};

export default WeeksByCalorie;
